import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Party } from 'src/app/models/party-manager/party';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import {
  FtthResourceService,
  Resource,
  resourceListToResourceTypeMap,
  ResSpecificationId
} from 'src/app/services/api/ftth-resource/ftth-resource.service';
import { Parent, ResourceTreeService } from 'src/app/services/utils/resource.tree.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { CharacteristicsConverter } from 'src/app/services/api/characteristics/characteristics.converter';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { ScaiService } from 'src/app/services/api/scai/scai.service';
import { map, pluck, switchMap, tap } from 'rxjs/operators';
import { RESOURCES_LEVEL } from 'src/app/utils/Constants';

export enum ComponentStateEnum {
  none = 'none',
  loading = 'loading',
  nodata = 'nodata',
  ready = 'ready',
}

@Component({
  selector: 'app-order-details-resource',
  templateUrl: './order-details-resource.component.html',
  styleUrls: ['./order-details-resource.component.css']
})
export class OrderDetailsResourceComponent implements OnInit, OnDestroy {
  
  isps: Party[];
  resource: Resource;
  contains: { [p in ResSpecificationId]?: Resource[]; };
  type: ResSpecificationId;
  cvlanLength = '0';
  resourceTree: Array<Parent>;
  ctoParent: Parent | null = null;
  activatedRoute: any;
  @Input() origin: any;
  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }
  characteristics: CharacteristicsObject;
  private subscriptions = new Subscription();
  componentState: BehaviorSubject<ComponentStateEnum> = new BehaviorSubject<ComponentStateEnum>(ComponentStateEnum.none);
  partyService: any;
  matTabGroup: any;
  namingId: string;
  previousId: string;
  scaiReference: string;
  generalInfo: OrderDetailsGeneralObject;
  inventoryUrl: string;

  constructor(private ordersService: OrdersService,
    private scaiService: ScaiService,
    private characteristicsConverter: CharacteristicsConverter,
    private ftthResourceService: FtthResourceService,
    private resourceTreeService: ResourceTreeService) {
  }

  
   
    ngOnInit() {   
      this.componentState.next(ComponentStateEnum.none);
      this.getCharacteristics();
    }

    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
  
    getSpecLength(resources?: Resource[]): string {
      if (resources) {
        return `${resources.length}`;
      }
  
      return '0';
    }
  
    hasAdministrationTab() {
      const administrationTabTypes: ResSpecificationId[] = ['OLTResSpec', 'OLTCardResSpec', 'OLTPortResSpec', 'CTOResSpec', 'SplitterResSpec', 'CTOPortResSpec'];
      return administrationTabTypes.includes(this.type);
    }
  
    private getCharacteristics(): void {
      this.ordersService.getServiceCharacteristics(this._params.map).subscribe(
        (data) => {
          this.characteristics = this.characteristicsConverter.convert(data);
          for (const item of this.characteristics.outputCharacteristics) {
            if(item.id === 'sc_network_splitter_id'){
              if(item.value.length > 0){
                this.namingId = "Splitter-"+item.value;
              }else{
                this.namingId = "";
                this.componentState.next(ComponentStateEnum.nodata);
              }
           }  
          }
          if(this.namingId != ""){
             this.loadResource();
          }
        }
      );
    }

    loadResource() {
      this.ftthResourceService.getResource(this.namingId).subscribe((res) => {      
            this.resource = res;
            this.contains = resourceListToResourceTypeMap(this.resource.contains);
            const parts = this.resource._links.self.href.split('/');
            this.resource['namingId'] = parts[parts.length - 1];
            this.loadParentTree();
            this.componentState.next(ComponentStateEnum.ready);
      });
    }
  
    private loadParentTree(): void {
      if (!this.resourceTree || this.resourceTree.length === 0) {
        this.resourceTree = this.resourceTreeService.getParents();
      }
      this.resourceTreeService.clearParents();
      const level = RESOURCES_LEVEL.find(res => res.name === this.resource.resourceType).level;
      if (level > 1) {
        // call to function to get parents of intermediate resources only if it's not OLT (first level)
        this.ftthResourceService.getParents(this.resource).subscribe((resp) => {
          if (resp) {
            resp.resources.forEach(element => {
              const resourceType = FtthResourceService.getResourceType(element.resourceSpec.namingId);
              element.resourceType = resourceType;
              // for ctoPorts and splitters, CTO is shown in another component, because it's not part of parent tree structure
              if (element.resourceType === 'CTO') {
                this.ctoParent = {
                  name: element.name,
                  namingId: element.namingId,
                  level: RESOURCES_LEVEL.find(res => res.name === element.resourceType).level,
                  title: element.resourceType
                };
              } else if (element.resourceType === 'OLTNode') { // we don't need this in Onivia network, but for other INOs we should remove this else if
                console.info(element);
              } else {
                this.resourceTreeService.sendParent({
                  name: element.name,
                  namingId: element.namingId,
                  level: RESOURCES_LEVEL.find(res => res.name === element.resourceType).level,
                  title: element.resourceType
                });
              }
            });
          }
          this.resourceTreeService.sendParent({
            name: this.resource.name,
            namingId: this.namingId,
            level: RESOURCES_LEVEL.find(res => res.name === this.resource.resourceType).level,
            title: this.resource.resourceType
          });
        });
      } else {
        // we have to recalculate here 1st element of tree, because in resource-search we don't have all data
        this.resourceTreeService.sendParent({
          level: 1,
          name: this.resource.name,
          namingId: this.namingId,
          title: this.resource.resourceType
        });
      }
    }

    
  
}
